import { User } from "../../../../auth/types";
import { httpWebApi } from "../../../../../core/http/httpThunks";
import { TradeReviewReportFilter } from "../types";

export const getTradeReviewReport = (
  user: User,
  filter: TradeReviewReportFilter
) => {
  return httpWebApi<Blob>({
    method: "GET",
    responseType: "blob",
    timeout: 60 * 4 * 1000,
    url: "reporting/gettradereviewreport",
    params: {
      userid: user.userId,
      datefrom: filter.datefrom,
      dateto: filter.dateto,
      productid: filter.productid,
    },
  });
};

export default getTradeReviewReport;
